import {
    AbstractControl
} from '@angular/forms';
export class PosValidators {


    static validateDocuments(control: AbstractControl) {
        let values = control.value.map(
            (m: any) => {
                return {
                    id: m.id,
                    documents: m.documents.map((x: any, i: number) => {
                        return {
                            document: x[`document_${m.id}_${i}`],
                            fileName: x[`document_fileName_${m.id}_${i}`]
                        }
                    })
                }
            }).map((m: any) => {
                return { valid: m.documents.some((s: any) => s.document != "" && s.fileName != "") }
            });

        if (!values.some((m: any) => m.valid)) {
            return {
                invalidDocuments: true
            };
        }
        return null;
    }
}
